import { initialState as paginationInitialState } from "../../../components/shared/pagination/PaginationWrapper";
import { DEFAULT_SITE, formTypes } from "../../../constants";

export const getCurrentDate = () => new Date().toJSON().slice(0, 10);

export const shouldFilterActiveLogs = (dateFrom, dateTo) => {
  const currentDate = getCurrentDate();
  return dateFrom >= currentDate && dateTo > currentDate;
};

export const buildSigneeFilter = (signee, signeeList) => {
  if (!signee || signee?.length === 0 || signee?.length === signeeList?.length) {
    return undefined;
  }

  const tempSignefilter = { or: [] };

  signee
    .toString()
    .split(",")
    .forEach((element) => {
      const firstLetter = element.charAt(0).toUpperCase();
      const rest = element.slice(1).toLowerCase();
      const SigneeUpper = firstLetter + rest;

      tempSignefilter.or.push({
        approverUserName: {
          eq: element.toLowerCase()
        }
      });
      tempSignefilter.or.push({
        approverUserName: {
          eq: element.toUpperCase()
        }
      });
      tempSignefilter.or.push({
        approverUserName: {
          eq: SigneeUpper
        }
      });
    });

  return tempSignefilter;
};

export const addActionLogFilters = (filter, dateFrom, dateTo) => {
  if (shouldFilterActiveLogs(dateFrom, dateTo)) {
    filter.logStatus = { eq: "ACTIVE" };
  }

  if (dateFrom && dateTo) {
    filter.actionDate = { between: [dateFrom, dateTo] };
  }
};

export const buildFilter = ({ equipmentModel, signee, dateFrom, dateTo, logType, signeeList }) => {
  const filter = {};

  if (equipmentModel) {
    filter.equipmentModel = { eq: equipmentModel };
  }

  const signeeFilter = buildSigneeFilter(signee, signeeList);
  if (signeeFilter) {
    filter.and = [signeeFilter];
  }

  if (logType === formTypes.ACTION_LOG) {
    addActionLogFilters(filter, dateFrom, dateTo);
  }

  return Object.keys(filter).length === 0 ? undefined : filter;
};

export const getQueryByInstrument = ({
  sortDirection,
  queryDesc,
  queryAsc,
  instrument,
  inventoryId,
  queryWithInstrumentDesc,
  queryWithInstrumentAsc
}) => {
  const hasInstrumentFilter = instrument || (typeof inventoryId !== "undefined" && inventoryId !== null);

  if (hasInstrumentFilter) {
    return sortDirection === "DESC" ? queryWithInstrumentDesc : queryWithInstrumentAsc;
  }

  return sortDirection === "DESC" ? queryDesc : queryAsc;
};

export const getQueryAndFilter = ({
  equipmentModel,
  signee,
  sortDirection,
  queryDesc,
  queryAsc,
  instrument,
  dateFrom,
  dateTo,
  queryWithInstrumentDesc,
  queryWithInstrumentAsc,
  inventoryId,
  logType,
  signeeList
}) => {
  const filter = buildFilter({
    equipmentModel,
    signee,
    dateFrom,
    dateTo,
    logType,
    signeeList
  });
  const query = getQueryByInstrument({
    sortDirection,
    queryDesc,
    queryAsc,
    instrument,
    inventoryId,
    queryWithInstrumentDesc,
    queryWithInstrumentAsc
  });

  return { query, filter };
};

export const extractVariables = ({ instrument, dateFrom, dateTo, storeUser, limit, nextToken, filter, inventoryId }) => {
  return {
    dateRange: dateFrom === null && dateTo === null ? undefined : [dateFrom, dateTo],
    site: storeUser?.site || DEFAULT_SITE,
    limit: limit || paginationInitialState.limit,
    nextToken,
    filter,
    inventoryId: instrument?.inventoryId ? instrument?.inventoryId : inventoryId,
    dateRangeBegin: dateFrom !== null ? dateFrom : "0001-01-01",
    dateRangeEnd: dateTo !== null ? dateTo : "9999-12-31"
  };
};

export const getUpdatedItems = (items) => {
  const updatedWithEquipIds = items.map((item) => {
    if (item.equipmentId === "null") {
      item.equipmentId = "";
    }

    ["systemStatus", "gxpReady"].forEach((field) => {
      item[field] = item[field]?.newValue ?? item[field];
    });

    return item;
  });
  return [...updatedWithEquipIds];
};
